// extracted by mini-css-extract-plugin
export default {"background":"MillionsBanner-module_background_oHvswICdpJ"};